import * as React from "react";
import {authorize} from "@athena-portal/components";
import {RouteComponentProps} from "react-router";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {ButtonLink} from "../../../../../components/navigation/ButtonLink";
import {setSessionStorage} from "../../../../../CommonFunctions";
import {FalconNavigatorHeader, CLAIM_TYPE_MOTOR, CLAIM_TYPE_BREAKDOWN, CLAIM_TYPE_OTHER} from "@falcon/services";

interface IPickAnnualMotorClaimKindPageParams {
    policyNumber: string;
}

interface IPickAnnualMotorClaimKindPageProps extends RouteComponentProps<IPickAnnualMotorClaimKindPageParams> {
    location: any;
}

interface IState {
    link: string,
    claimTypeChecked: string,
}

@authorize
export class PickAnnualMotorClaimKindPage extends React.Component<IPickAnnualMotorClaimKindPageProps, IState> {
    private pluginTemplates = new PluginTemplates();

    private claimTypes = new Map<string,string>([
        [CLAIM_TYPE_MOTOR,"Windscreen or window claim"],
        [CLAIM_TYPE_BREAKDOWN,"Breakdown claim"],
        [CLAIM_TYPE_OTHER,"All other claims (road traffic accident, theft, misfuelling, stolen or lost keys, etc)"]
    ]);

    constructor(props: IPickAnnualMotorClaimKindPageProps) {
        super(props);

        this.state = {
            link: "",
            claimTypeChecked: "",
        };
    }

    public componentDidMount(): void {
        window.scrollTo(0, 0);
        this.pluginTemplates.setPageTitle("Make a car claim");
    }

    public render() {

        return (
            <React.Fragment>

                <FalconHeader/>
                <div className="plugin claims">
                    <FalconNavigatorHeader
                        back={`/dashboard/annualMotor/${this.props.match.params.policyNumber}`}
                        title="Make a car claim"
                    />
                    <div>
                        <div className="page-contents">
                            <div className="banner banner-info">
                                <div className="banner-text">
                                    Your claim will be handled by Allianz
                                </div>
                            </div>
                            {this.renderClaimRadioButtons(this.claimTypes)}
                        </div>
                        <div className="px-4 px-md-0 ml-md-19 padding-0">
                            {(this.state.claimTypeChecked === "" || this.state.claimTypeChecked !== CLAIM_TYPE_OTHER || !this.getOtherClaimsExternalEnabled()) && <ButtonLink to={this.state.link} primary={true} routeState={{prevPath: location.pathname}}
                                            disabled={this.state.link === ""}
                                            className={"float-right-desktop"}> Next </ButtonLink>}
                            {this.state.claimTypeChecked === CLAIM_TYPE_OTHER && this.getOtherClaimsExternalEnabled() && <a href={this.state.link} className={"float-right-desktop"}>
                                <button type="button" className={`btn btn-primary btn-next plugin`}> Next </button>
                            </a>}
                        </div>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, `/dashboard/annualMotor/${this.props.match.params.policyNumber}`)}
                </div>
                <FalconFooter/>

            </React.Fragment>
        );
    }

    private handleOnChangeEvent = (event: any): void => {
        const value = event.currentTarget.value;
        const otherClaimsExternalEnabled: boolean = this.getOtherClaimsExternalEnabled();

        if(this.claimTypes.has(value)) {
            let claimsLink = "";
            if (value === CLAIM_TYPE_OTHER && otherClaimsExternalEnabled) {
                claimsLink = `${process.env.REACT_APP_MOTOR_OTHER_CLAIM_URL}` + '?journey=digital&policy=' + `${this.props.match.params.policyNumber}`;
            } else {
                claimsLink = `/dashboard/wolfWindscreenOrBreakdownPage/${this.props.match.params.policyNumber}`;
            }

            this.setState({
                claimTypeChecked: value,
                link: claimsLink
            });

            setSessionStorage("claim", value);
        }
    };

    private getOtherClaimsExternalEnabled() {
        return process.env.REACT_APP_MOTOR_OTHER_CLAIM_EXTERNAL_ENABLED ? JSON.parse(process.env.REACT_APP_MOTOR_OTHER_CLAIM_EXTERNAL_ENABLED) : false;
    }

    private renderClaimRadioButtons(claimTypes: Map<string,string>): JSX.Element{

        const radioButtons: JSX.Element[] = [];
        claimTypes.forEach((value,key)=>
        radioButtons.push(
            <div key={key} className="custom-control mt-2 ml-2 mb-3">
                <input
                    className={"custom-radiobutton cursor-pointer"}
                    type="radio"
                    name={key + "-claim"}
                    id={key + "-claim"}
                    value={key}
                    checked={this.state.claimTypeChecked === key}
                    onChange={this.handleOnChangeEvent}
                />
                <label id={'claim-type-label'} className="checkbox-label label-bg-transparent"
                       htmlFor={key + "-claim"}>
                    {value}
                </label>
            </div>)
        );
        return (
            <div className="panel margin-top-30 padding-top-10">
                <p className="font-weight-semi-bold">Please choose what type of claim you want to make?</p>
                <div>{radioButtons}</div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/annual/motor/claims/PickAnnualMotorClaimKindPage.tsx